module.exports = __webpack_public_path__ + "static/media/link.4e62e45f.svg";